// extracted by mini-css-extract-plugin
export default {"simpleDropdownItem":"SimpleDropdownItem-module__simpleDropdownItem___2DH93","iconContainer":"SimpleDropdownItem-module__iconContainer___rbt3n"};